/* The kiosk's sign-in words, from the till's copy table (the Arabic sheet's scope).
 * The screen is shared with the dashboard, which passes its own table's words. */
import type { MerchantSignInWords } from "@damga/ds";
import { t } from "@damga/kit";

export const signInWords: MerchantSignInWords = {
  title: t("merchantSignIn.title"),
  body: t("merchantSignIn.body"),
  username: t("merchantSignIn.username"),
  password: t("merchantSignIn.password"),
  showPassword: t("merchantSignIn.show"),
  hidePassword: t("merchantSignIn.hide"),
  submit: t("merchantSignIn.submit"),
  working: t("merchantSignIn.working"),
  refused: t("merchantSignIn.refused"),
  codeTitle: t("merchantSignIn.codeTitle"),
  codeBody: t("merchantSignIn.codeBody"),
  codeLabel: t("merchantSignIn.codeLabel"),
  verify: t("merchantSignIn.verify"),
  codeRefused: t("merchantSignIn.codeRefused"),
  codeIncomplete: t("merchantSignIn.codeIncomplete"),
  startAgain: t("merchantSignIn.startAgain"),
  tooManyCodes: t("merchantSignIn.tooManyCodes"),
  mailDown: t("merchantSignIn.mailDown"),
  unreachable: t("merchantSignIn.unreachable"),
};
